import React from 'react';
import './index.css';

export const AccountDeletion = require('./container').default;